import moment from "moment";

function SlotTimings({
  start,
  end,
  isToggled,
  style: customStyle,
  className,
}: {
  start: string | undefined;
  end?: string | undefined;
  isToggled?: boolean;
  style?: string;
  className?: string;
}) {
  const formattedStart = start
    ? moment(start, ["HH:mm:ss", "HH:mm", moment.ISO_8601]).format("hh:mmA")
    : "";

  const formattedEnd =
    end && moment(end, ["HH:mm:ss", "HH:mm", moment.ISO_8601]).isValid()
      ? moment(end, ["HH:mm:ss", "HH:mm", moment.ISO_8601]).format("hh:mmA")
      : null;

  return (
    <div
      className={`text-xs mx-1 bg-[#030303] text-white px-2 py-2 rounded-full justify-center text-center ${customStyle || ''} ${className || ''}`}
    >
      {formattedStart}
      {/* ✅ only show dash + end if end exists */}
      {formattedEnd ? ` - ${formattedEnd}` : ""}
    </div>
  );
}

export default SlotTimings;
